import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: "AIzaSyCM0AN5QqjoUAbeYgQCYeK6mZOj4bGFJd8",
  authDomain: "lift-coach-ai.firebaseapp.com",
  projectId: "lift-coach-ai",
  storageBucket: "lift-coach-ai.firebasestorage.app",
  messagingSenderId: "939950473809",
  appId: "1:939950473809:web:561eef3a7150c21b706e70",
  measurementId: "G-PVFK6ZZ2GJ",
};

const app = initializeApp(firebaseConfig);

// eslint-disable-next-line no-unused-vars
const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider('6Ldv7OcrAAAAAH813M9f10jZiofUAJ0MpLgJSilG'),
  isTokenAutoRefreshEnabled: true
});

export default app;
